import React from "react";
const Email = React.forwardRef(({ filled = false, size = 20, ...props }, ref) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M7 12C3 12 3 13.79 3 16V17C3 19.76 3 22 8 22H16C20 22 21 19.76 21 17V16C21 13.79 21 12 17 12C16 12 15.72 12.21 15.2 12.6L14.18 13.68C13 14.94 11 14.94 9.81 13.68L8.8 12.6C8.28 12.21 8 12 7 12Z"
      stroke={filled ? "white" : "#4B4E4F"}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 12V6C19 3.79 19 2 15 2H9C5 2 5 3.79 5 6V12"
      stroke={filled ? "white" : "#4B4E4F"}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.55 9.23H13.88"
      stroke={filled ? "white" : "#4B4E4F"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.71997 6.23H14.72"
      stroke={filled ? "white" : "#4B4E4F"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
Email.displayName = 'Email';

export default Email;
